'use strict';

import BaseService from './base.service';

class CronologiesService extends BaseService {
  static $inject = ['Cronology', 'SegaUser'];
  Cronology: any;

  constructor(Cronology, SegaUser) {
    super(Cronology, SegaUser);
    Object.assign(this, {
      Cronology
    });
  }
}
export default CronologiesService;
